import React from "react";
import SSMLLint from "./SSMLLint";

const Hero = () => {
    return (
        <main className="max-w-4xl mx-auto px-6 py-8 flex-1">
            <SSMLLint />
        </main>
    )
}

export default Hero
